<template>
  <div class="container">
    <div id="get-sign-in-code"></div>
    <div class="card margin-top">
      <div class="title-register">
      
        <router-link class="navbar-brand" :to="{ name: 'Home' }"><img alt="Secc logo" src="@/assets/secclogo.png" /></router-link>
        <h3 class="font-moul pt-3" style="font-size:14px; text-align:center;line-height: 30px;">
          ប្រព័ន្ធចុះឈ្មោះ និងការបង់ថ្លៃតាមអនឡាញ សម្រាប់វគ្គបណ្ដុះបណ្ដាលនិងការប្រឡង និងកម្មវិធីអប់រំវិជ្ជាជីវៈបន្តក្នុងវិស័យមូលបត្រ
        </h3>
        <h3 class="font-moul pt-3" style="font-size:14px; text-align:center;">
          {{$t("message.create_account")}}
          សូមបំពេញព៍ត៌មានបន្ថែម
        </h3>
      </div>
      <div class="card-body" ref="formContainer">
        <div class="card">
          <div
            class="card-body"
            style="margin:auto;width:80%;"
          >
            <form v-on:submit.prevent>
              <label class="form-label">{{$t("message.type_of_trainee")}}<span class="text-danger">*</span></label>
              <div class="input-group mb-3">
                <select
                  class="form-select"
                  :class="{ 'is-invalid': v$.form.participant_type.$error }"
                  v-model="form.participant_type"
                  
                  id="inputGroupSelect01"
                >
                  <option selected>Choose...</option>
                  <option value="1">{{$t("message.individual")}} ({{$t("message.individual")}})</option>
                  <option value="2">{{$t("message.institution")}} ({{$t("message.company")}})</option>
                </select>
              </div>
              <span v-if="form.participant_type == 2">
                <label for="" class="form-label">{{$t("message.company_name")}}<span class="text-danger">*</span></label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model.trim="form.company_name"
                    
                    aria-label=""
                    class="form-control"
                    :placeholder='$t("message.company_name")'
                    :class="{ 'is-invalid': v$.form.company_name.$error }"
                  />
                </div>
              </span>

              <label for="lastname-firstname" class="form-label"
                >{{$t("message.full_name")}}({{$t("message.in_khmer")}})<span class="text-danger">*</span></label
              >
              <div class="input-group mb-3">
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model.trim="form.lastname"
                    
                    aria-label="Last name"
                    class="form-control"
                    :placeholder='$t("message.last_name")'
                    :class="{ 'is-invalid': v$.form.lastname.$error }"
                    disabled
                  />
                  <div class="invalid-feedback" v-if="errors?.lastname">
                    {{errors?.lastname[0]}}
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model.trim="form.firstname"
                    
                    aria-label="First name"
                    class="form-control"
                    :placeholder='$t("message.first_name")'
                    :class="{ 'is-invalid': v$.form.firstname.$error }"
                    disabled
                  />
                  <div class="invalid-feedback" v-if="errors?.firstname">
                    {{errors?.firstname[0]}}
                  </div>
                </div>
              </div>

              <label for="lastname-firstname-latine" class="form-label"
                >{{$t("message.full_name")}}({{$t("message.in_latin")}})<span class="text-danger">*</span></label
              >
              <div class="input-group mb-3">
                
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model="form.lastname_en"
                    disabled
                    aria-label="Last name"
                    :placeholder='$t("message.last_name")'
                    class="form-control"
                    :class="{ 'is-invalid': v$.form.lastname_en.$error }"
                  />
                  <div class="invalid-feedback" v-if="errors?.lastname_en">
                    {{errors?.lastname_en[0]}}
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model="form.firstname_en"
                    disabled
                    aria-label="First name"
                    :placeholder='$t("message.first_name")'
                    class="form-control"
                    :class="{ 'is-invalid': v$.form.firstname_en.$error }"
                  />
                  <div class="invalid-feedback" v-if="errors?.firstname_en">
                    {{errors?.firstname_en[0]}}
                  </div>
                </div>
              </div>

              <label for="first-name" class="form-label">{{$t("message.gender")}}<span class="text-danger">*</span></label>
              <div class="input-group mb-3">
            
                <select
                  disabled
                  class="form-select"
                  :class="{ 'is-invalid': v$.form.gender.$error }"
                  v-model="form.gender"
                  id="inputGroupSelect01"
                >
                  <option selected>Choose...</option>
                  <option value="1">ប្រុស (Male)</option>
                  <option value="2">ស្រី (Female)</option>
                </select>
              </div>

              <label for="dob" class="form-label">{{$t("message.dob")}}<span class="text-danger">*</span></label>
              <div class="input-group mb-3">
              
                <input
                  v-maska="'##/##/####'"
                  v-model="form.dob"
                  class="form-control"
                  :class="{ 'is-invalid': v$.form.dob.$error }"
                  id="dob"
                  disabled
                  placeholder="dd/mm/yyyy"
                  aria-label="date_of_birth"
                  aria-describedby="dob2"
                />
              </div>

              <label for="nationality" class="form-label">{{$t("message.nationality")}}<span class="text-danger">*</span></label>
              <div class="input-group mb-3">
                <!-- <label class="input-group-text" for="nationality2"
                >Nationality</label
              > -->
                <select
                  id="nationality"
                  v-model="form.nationality"
                  class="form-select"
                  disabled
                  :class="{ 'is-invalid': v$.form.nationality.$error }"
                  aria-label="Default select example"
                  searchable="Search here.."
                >
                  <option selected>Open this select menu</option>
                  <option
                    v-for="item in countryCode"
                    :key="item.id"
                    :value="item.code"
                    >{{ item.name }}</option
                  >
                </select>
              </div>
              <label for="lastname-firstname" class="form-label"
                >{{$t("message.nationality_idcard_or_passport")}}<span class="text-danger">*</span></label
              >
              <div class="input-group mb-3">
                
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.form.national_id_card.$error }"
                  v-model="form.national_id_card"
                  disabled
                  aria-describedby="idcard"
                />
                <div class="invalid-feedback" v-if="errors?.national_id_card">
                    {{errors?.national_id_card[0]}}
                </div>
              </div>

              <label for="lastname-firstname" class="form-label"
                >{{$t("message.available_contact")}}<span class="text-danger">*</span></label
              >
              <div class="input-group mb-3">
                <!-- <span class="input-group-text" id="phone2">Phone</span> -->
                <input
                  type="text"
                  v-maska="'##########'"
                  v-model="form.phone"
                  class="form-control"
                  :class="{ 'is-invalid': v$.form.phone.$error }"
                  id="basic-url"
                  disabled
                  aria-describedby="phone2"
                />
                <div class="invalid-feedback" v-if="errors?.phone">
                    {{errors?.phone[0]}}
                </div>
              </div>

              <label for="lastname-firstname" class="form-label">{{$t("message.email")}}<span class="text-danger">*</span></label>
              <div class="input-group mb-3">
                <!-- <span class="input-group-text" id="idcard">Email</span> -->
                <input
                  type="text"
                  v-model="form.email"
                
                  :class="{ 'is-invalid': v$.form.email.$error }"
                  class="form-control"
                
                />
                <div class="invalid-feedback" v-if="errors?.email">
                    {{errors?.email[0]}}
                </div>
              </div>

             
              <div class="saveNext">
                <button
                  type="button"
                  @click="saveConfirm"
                  class="btn btn-primary"
                >
                  {{$t("message.create_account")}}
                </button>

              </div>
            </form>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import firebase from "firebase";
import axios from "@/axios";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf, email } from "@vuelidate/validators";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      form: {}
    };
  },
  validations() {
    return {
      form: {
        participant_type: { required, $autoDirty: true },
        company_name: {
          requiredIf: requiredIf(() => {
            return this.form?.participant_type == 2;
          }),
          $autoDirty: true
        },
        firstname: { required, $autoDirty: true },
        lastname: { required, $autoDirty: true },
        firstname_en: { required, $autoDirty: true },
        lastname_en: { required, $autoDirty: true },
        gender: { required, $autoDirty: true },
        dob: { required, $autoDirty: true },
        nationality: { required, $autoDirty: true },
        national_id_card: { required, $autoDirty: true },
        phone: { required, $autoDirty: true },
        email: { required, email, $autoDirty: true },
      }
    };
  },
  computed: {
    ...mapGetters({
      userCamDigit: "getOnlyUserCamDigit",
      countryCode: "getCountryCode"
    })
  },
  methods: {
    ...mapActions(["act_loadCountryCode"]),
    initailForm(){
      if(!this.userCamDigit){
        this.$router.push({ name: "errorlogin" });
      }
      this.form = {
        participant_type: 1,
        company_name: "",
        firstname: this.userCamDigit?.first_name_kh,
        lastname: this.userCamDigit?.last_name_kh,
        firstname_en: this.userCamDigit?.first_name_en,
        lastname_en: this.userCamDigit?.last_name_en,
        gender: this.userCamDigit?.gender=='M' ? '1' : '2',
        dob: this.userCamDigit?.dob,
        nationality: this.userCamDigit?.nationality,
        national_id_card: this.userCamDigit?.personal_code,
        phone: this.userCamDigit?.mobile_phone,
        email: this.userCamDigit?.email,
        camdigikey_id: this.userCamDigit?.camdigikey_id,
        accessToken: this.userCamDigit?.accessToken,
      };
    },
    showLoader() {
      return this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    async saveConfirm() {
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {
        let loader = this.showLoader();
        try {
          let summitForm = { ...this.form };
          summitForm.nationality = this.countryCode.filter(item=>item.code == this.form.nationality)[0]?.id;
          let response = await axios.post("create-account-camdigikey", summitForm);
          if(response.data.status){
            this.$store.commit('changeAuthCode',response.data.data);
            this.$store.commit('changeUserCamDigit',{});
            this.$router.push({ name: "register" });
          }
          loader.hide();
        } catch (error) {
          loader.hide();
          this.$toast.open({
                message: "data already exist! : " + Object.keys(error.response.data.errors).join(', '),
                type: "error",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
        }
        
      } else {
        this.$toast.open({
          message: "Form is invalid",
          type: "error",
          duration: 5000,
          dismissible: true,
          position: "top-right"
        });
      }
    }
  },
  created() {},
  mounted() {
    this.initailForm();
    this.act_loadCountryCode();
  }
};
</script>
<style scoped>
.margin-top {
  margin-top: 50px;
  background-color: rgb(238, 238, 238);
}
</style>
